import _ from 'underscore';
import Numeral from 'numeral';
import Cache from 'root/cache';
import Svg_Icon from 'root/module/svg_icon';
import View from 'view/base';

export default View.extend({
    className: 'grid-4-8 grid-none-mobile',

    initialize: function(options) {
        this.data = options.data;
    },

    render: function() {
        var count          = this.data.count;
        var rating_total   = this.data.people;
        var rating_average = rating_total ? (count.r1 * 1 + count.r2 * 2 + count.r3 * 3 + count.r4 * 4 + count.r5 * 5) / rating_total : 0;
        var project_key    = Cache.getDefaultProject().get('project_key');

        var max_rating = 0;
        _.each(count, function(rating) {
            max_rating = Math.max(rating, max_rating);
        });

        var html =
        '<div class="padding-40 padding-20-phone">' +
            '<h2>Average</h2>' +
            '<div class="rating-icon">' + Svg_Icon.star + '</div>' +
            '<div>' +
                '<div class="figure">' + rating_average.toFixed(2) + '</div>' +
                '<div class="info">' + Numeral(rating_total).format('0,0') + ' people rated</div>' +
            '</div>' +
        '</div>' +
        '<div class="gradient-line-left padding-20-phone">' +
            '<div class="rating-container">' +
                '<div class="axis-y">' +
                    '<div class="max">' + max_rating + '</div>' +
                    '<div class="min">0</div>' +
                '</div>' +
                '<div class="bar"><a href="/' + project_key + '/feedback/?rating=1"    class="meteor navigation" style="height:' + (max_rating ? (count.r1 / max_rating * 100) : 1) + '%"></a><span class="number">1</span></div>' +
                '<div class="bar"><a href="/' + project_key + '/feedback/?rating=2"    class="meteor navigation" style="height:' + (max_rating ? (count.r2 / max_rating * 100) : 1) + '%"></a><span class="number">2</span></div>' +
                '<div class="bar"><a href="/' + project_key + '/feedback/?rating=3"    class="meteor navigation" style="height:' + (max_rating ? (count.r3 / max_rating * 100) : 1) + '%"></a><span class="number">3</span></div>' +
                '<div class="bar"><a href="/' + project_key + '/feedback/?rating=4"    class="meteor navigation" style="height:' + (max_rating ? (count.r4 / max_rating * 100) : 1) + '%"></a><span class="number">4</span></div>' +
                '<div class="bar"><a href="/' + project_key + '/feedback/?rating=5"    class="meteor navigation" style="height:' + (max_rating ? (count.r5 / max_rating * 100) : 1) + '%"></a><span class="number">5</span></div>' +
                '<div class="bar"><a href="/' + project_key + '/feedback/?rating=up"   class="meteor navigation" style="height:' + (max_rating ? (count.t_up   / max_rating * 100) : 1) + '%"></a><span class="number"><i class="far fa-thumbs-up"></i></span></div>' +
                '<div class="bar"><a href="/' + project_key + '/feedback/?rating=down" class="meteor navigation" style="height:' + (max_rating ? (count.t_down / max_rating * 100) : 1) + '%"></a><span class="number"><i class="far fa-thumbs-down"></i></span></div>' +
            '</div>' +
        '</div>';

        this.$el.html(html);
        return this;
    }
});